<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-setting"></i>
              材料后期工艺管理
            </h1>
            <p class="page-subtitle">管理材料可选的后期工艺配置，关联材料与后期工艺</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加后期工艺时长" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton()"></el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item>
                <el-input v-model="searchCondition.follow_craft_title" placeholder="请输入后期工艺名称" clearable prefix-icon="el-icon-setting">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
        <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column slot="first-column" width="60" label="序号" align="center">
            <template slot-scope="scope">
                <span class="sequence-number">{{offset+scope.$index+1}}</span>
            </template>
          </el-table-column>

            <el-table-column label="后期工艺信息" min-width="300">
            <template slot-scope="scope">
                <div class="craft-info">
                  <div class="craft-item">
                    <div class="craft-header">
                      <i class="el-icon-setting"></i>
                      <span class="craft-name">{{scope.row.follow_craft_name}}</span>
                      <el-tag size="mini" type="primary">后期工艺</el-tag>
                    </div>
                    <div class="craft-description" v-if="scope.row.follow_craft_desc">
                      <i class="el-icon-document"></i>
                      <span>{{scope.row.follow_craft_desc | truncate(50)}}</span>
                    </div>
                  </div>
                </div>
            </template>
          </el-table-column>

            <el-table-column v-if="buttonType=='icon'" width="150" label="操作" align="center">
            <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑工艺" placement="top">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
              </el-tooltip>
                  <el-popconfirm
                    title="确定删除该后期工艺关联？"
                    @confirm="deleteButton(scope.row.id)"
                    @onConfirm="deleteButton(scope.row.id)">
                    <el-button slot="reference" size="mini" icon="el-icon-delete" circle type="danger"></el-button>
                  </el-popconfirm>
                </div>
            </template>
          </el-table-column>
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="后处理工艺" prop="follow_craft_ids">
                <el-select 
                  v-model="formData.follow_craft_ids" 
                  multiple 
                  placeholder="请选择后处理工艺"
                  style="width: 100%"
                  filterable>
                  <el-option
                    v-for="item in filteredFollowCraftList"
                    :key="item.id"
                    :label="item.follow_craft_name"
                    :value="item.id">
                    <span style="float: left">{{ item.follow_craft_name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.follow_craft_type }}</span>
                  </el-option>
                </el-select>
                <div class="form-tips">
                  <i class="el-icon-info"></i>
                  <span>可选择多个后处理工艺，已选择的工艺将关联到当前材料</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      searchCondition: {
        current_page: 1,
        page_size: 20,
        follow_craft_title:'',
        query: "",
        params: [],
      },
      list:[],
      followCraftList:[],
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        page_size: 20,
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        follow_craft_name: [{required: true,message:'输入后期工艺名称', trigger: 'blur' }],
        material_duration_value: [{required: true,message:'输入后期工艺时长描述', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      deletingMap: {},
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    filteredFollowCraftList() {
      const editingId = this.formData && this.formData.id != null && this.formData.id !== ''
        ? String(this.formData.id)
        : ''
      const used = new Set()
      this.dataList.forEach((row) => {
        if (editingId && String(row.id) === editingId) return
        if (row.follow_craft_id) used.add(String(row.follow_craft_id))
      })
      return this.followCraftList.filter((fc) => !used.has(String(fc.id)))
    },
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 搜索
    searchButton() {
      this.getList()
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {
        id:'',
        follow_craft_ids:[]
      }
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据：'+id
      let res = await this.$api.post('/service/ola_app_material_follow_craft/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/material_follow_craft/multiple_create'
      this.formData.material_id = this.$route.params.id
      if(this.formData.id!=''){
        url = '/service/material_follow_craft/multiple_update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initFormData()
      }else{
        this.$message.error(res.info)
      }
      this.drawerData.loading = false
      this.drawerData.visible = false
      this.getList() 
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.craft_status=='0'){
        row.craft_status='1'
      }else{
        row.craft_status='0'
      }
      let id = await this.$api.modifyMaterialFollowCraft(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.getList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      if (this.deletingMap[id]) return
      this.$set(this.deletingMap, id, true)
      try {
        let res = await this.$api.post('/service/ola_app_material_follow_craft/delete', { id })
        if (this.$apiSuccess(res)) {
          this.$message.success('删除成功!')
          this.$nextTick(async () => {
            this.getList()
          })
        } else {
          this.$message.error((res && (res.message || res.info)) || '删除失败')
        }
      } finally {
        this.$set(this.deletingMap, id, false)
      }
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 初始化数据列表
    async getList() {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition,pagingInfo)
      this.searchCondition.query= ' material_id=?'
      this.searchCondition.params = [this.$route.params.id]
      if (this.searchCondition.follow_craft_title != ''){
        this.searchCondition.query += ' and instr(follow_craft_title,?)>0'
        this.searchCondition.params.push(this.searchCondition.follow_craft_title)
      }
      this.searchCondition.material_id = this.$route.params.id
      let res = await this.$api.post('/service/ola_app_material_follow_craft/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.dataList = res.data.list
        this.pagingData.total = res.data.page.total
      }else{
        this.dataList=[]
      }
      this.loadingStaus=false
    },
    // 初始化数据列表
    async getFollowCrafts() {
      this.loadingStaus=true
      let res = await this.$api.post('/service/ola_app_follow_craft/list',{})
      if (this.$apiSuccess(res)){
          this.followCraftList = res.data.list
      }else{
        this.followCraftList=[]
      }
      this.loadingStaus=false
    }
  },
  mounted() {
    this.getFollowCrafts()
    this.getList()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
    font-size 24px
      font-weight 600
      display flex
      align-items center
    margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 工艺信息样式
.craft-info
  .craft-item
    background #f8f9fa
    border-radius 8px
    padding 12px
    transition all 0.3s ease
    
    &:hover
      background #ecf5ff
      transform translateY(-2px)
    
    .craft-header
      display flex
      align-items center
      gap 8px
      margin-bottom 8px
      
      i
        color #409eff
        font-size 16px
      
      .craft-name
        font-weight 600
        color #303133
        flex 1
      
      .el-tag
        font-size 10px
    
    .craft-description
      display flex
      align-items center
      gap 6px
      font-size 12px
      color #606266
      line-height 1.4
      
      i
        color #909399
        font-size 14px

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 表单提示样式
.form-tips
  display flex
  align-items center
  gap 6px
  margin-top 8px
  padding 8px 12px
  background #f0f9ff
  border-radius 6px
  font-size 12px
  color #409eff
  
  i
    font-size 14px

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px
  
  .el-select-dropdown
    border-radius 8px
    
  .el-select-dropdown__item
    border-radius 4px
    margin 2px 8px
</style>
